import React, { useRef } from 'react';
import { useState } from 'react';
import { AppImages } from '../assets/s3';
import NavBar from '../components/navbar';
import { cardFAQs } from '../constants/data';
import { IoIosArrowUp, IoIosArrowDown } from 'react-icons/io';
import globe from '../assets/lottie/globe.json';
import tokenSupported from '../assets/lottie/tokenSupported.json';
import offRamp from '../assets/lottie/offRamp.json';
import gridFlow from '../assets/lottie/gridFlow.json';
import supportBusiness from '../assets/lottie/supportBusinuess.json';
import cardLoad from '../assets/lottie/cardLoad.json';
import { Player } from '@lottiefiles/react-lottie-player';
import FooterSection from '../components/footer';
import { PiArrowCircleRightFill } from 'react-icons/pi';
import SignUpNowModal from '../components/modals/signUpNowModal';
import cardsHeroImg from '../assets/card/cardsHeroImg.png';

export default function CypherCard() {
  const [expandedIndex, setExpandedIndex] = useState(null);
  const animatedDivRefs = useRef({});
  const [showModal, setShowModal] = useState(false);

  const toggleFAQ = (index) => {
    if (index === expandedIndex) {
      setExpandedIndex(null);
    } else {
      setExpandedIndex(index);
    }
  };

  const handleMouseEnter = (id) => {
    animatedDivRefs.current[id]?.play();
  };

  const handleMouseLeave = (id) => {
    animatedDivRefs.current[id]?.stop();
  };

  return (
    <div class='overflow-y-scroll text-[#434343] bg-white h-screen overflow-x-hidden'>
      <div class='pt-5'>
        <NavBar />
      </div>
      <SignUpNowModal showModal={showModal} setShowModal={setShowModal} />
      <div class='flex flex-col items-center justify-center min-h-screen w-full'>
        <div
          class={
            'bg-cover bg-center h-[855px] md:h-[955px] lg:h-[1160px] 2xl:h-[1260px] min-[2450px]:h-[1460px] min-[2900px]:h-[1560px] w-full relative'
          }
          style={{ backgroundImage: `url("${cardsHeroImg}")` }}
        >
          <div class='w-full px-5 leading-10 lg:mx-auto text-left lg:text-center mt-[126px] md:mt-[168px]'>
            <div>
              <div class='text-[28px] md:text-5xl lg:text-6xl font-bold text-gray-700 md:mb-4'>
                Get Closer with{' '}
                <span className='text-[#FFB900]'>your Idol,</span>
              </div>
              <div className='text-[28px] md:text-4xl lg:text-5xl font-semibold text-gray-700 '>
                With our <span className='text-[#FFB900]'>super card.</span>
              </div>
            </div>
            <div className='flex flex-row items-center lg:justify-center mt-4 lg:mt-10'>
              <div
                className='flex flex-row items-center justify-center bg-[#FFB900] lg:bg-primarybuttonBg py-2.5 px-7 rounded-full cursor-pointer'
                onClick={() => setShowModal(true)}
              >
                <p className='text-md font-bold'>Signup Now</p>
                <PiArrowCircleRightFill className='block lg:hidden w-6 h-6 ml-1.5' />
              </div>
            </div>
            <div
              class='hidden lg:block text-gray-700 underline mt-3 text-sm font-semibold cursor-pointer'
              onClick={() =>
                window.open('https://app.cypherhq.io/#/card', '_blank')
              }
            >
              I have invite code
            </div>
          </div>
          <div className='absolute bottom-16 w-full mx-auto px-4 text-center'>
            <p className='font-normal text-lg lg:text-[32px] tracking-[-0.25px] text-[#FFFFFF]'>
              Master® Debit Card which let you spend crypto Worldwide!
            </p>
          </div>
        </div>

        <div className='relative w-full'>
          <div
            className='invisible lg:visible w-[1px] h-full absolute top-0 left-[6%] -z-10'
            style={{
              background:
                'linear-gradient(#A7A7A7 16%, #E8E8E8 100%, #EDEDED 100%, #DADADA 100%)',
            }}
          />
          <div
            className='invisible lg:visible w-[1px] h-full absolute top-0 right-[6%] -z-10'
            style={{
              background:
                'linear-gradient(#B6B6B6 16%, #E8E8E8 100%, #EDEDED 100%, #DADADA 100%)',
            }}
          />

          <div className='mt-16 lg:mt-24'>
            <div className='invisible lg:visible w-full h-[1px] bg-[#EEEEEE] ' />
            <h1
              className='text-2xl md:text-4xl px-10 py-1 font-semibold text-center my-7'
              style={{
                background: 'linear-gradient(to bottom, #000000, 55%, #7F7F7F)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Supercharge your crypto spend journey
            </h1>
            <div className='invisible lg:visible w-full h-[1px] bg-[#EEEEEE] ' />
            <div className='mx-auto mt-16 lg:mt-[70px]'>
              <div className='flex flex-col lg:flex-row items-center justify-center px-16'>
                <div className='flex flex-col w-[330px] items-center lg:ml-16 lg:mr-6'>
                  <div
                    className='h-[188px] bg-[#1F1F1F] relative w-full flex flex-col overflow-hidden rounded-xl mb-6'
                    id='animatedDiv1'
                    onMouseEnter={() => handleMouseEnter('animatedDiv1')}
                    onMouseLeave={() => handleMouseLeave('animatedDiv1')}
                  >
                    <div className='absolute left-[127px] bottom-0'>
                      <Player
                        ref={(ref) =>
                          (animatedDivRefs.current['animatedDiv1'] = ref)
                        }
                        loop={true}
                        src={globe}
                        className={'h-[324px] w-[324px]'}
                        autoPlay={false}
                        keepLastFrame={true}
                      />
                    </div>
                    <div className='max-w-[150px] absolute bottom-6 left-6'>
                      <p className='text-xl text-[#FFFFFF] tracking-tight'>
                        Available Globally
                      </p>
                      <p className='text-xs text-[#C8C8C8] mt-1'>
                        Make payment on <br /> 40m+ Pos across globe
                      </p>
                    </div>
                  </div>
                  <div
                    className='h-[286px] w-full bg-[#F2F3F6] relative flex flex-col overflow-hidden rounded-xl mb-6'
                    id='animatedDiv2'
                    onMouseEnter={() => handleMouseEnter('animatedDiv2')}
                    onMouseLeave={() => handleMouseLeave('animatedDiv2')}
                  >
                    <div className='absolute mt-[-5%]'>
                      <Player
                        ref={(ref) =>
                          (animatedDivRefs.current['animatedDiv2'] = ref)
                        }
                        loop={true}
                        src={tokenSupported}
                        className={'max-w-[270px] max-h-[280px]'}
                        autoplay={false}
                        keepLastFrame={true}
                      />
                    </div>
                    <div className='max-w-[215px] absolute bottom-6 left-6'>
                      <p className='text-xl text-[#000000] tracking-tight'>
                        Support 200+ Tokens
                      </p>
                      <p className='text-xs text-[#555555] mt-1'>
                        Support 200+ Tokens across 12+chains
                      </p>
                    </div>
                  </div>
                  <div
                    className='h-[144px] bg-[#1F1F1F] relative w-full flex flex-col overflow-hidden rounded-xl'
                    id='animatedDiv3'
                    onMouseEnter={() => handleMouseEnter('animatedDiv3')}
                    onMouseLeave={() => handleMouseLeave('animatedDiv3')}
                  >
                    <div className='absolute right-[-12px] top-[-12px]'>
                      <Player
                        ref={(ref) =>
                          (animatedDivRefs.current['animatedDiv3'] = ref)
                        }
                        loop={true}
                        src={offRamp}
                        className={'max-h-[164px] max-w-[164px]'}
                        autoPlay={false}
                        keepLastFrame={true}
                      />
                    </div>
                    <div className='max-w-[210px] absolute bottom-6 left-6'>
                      <p className='text-xl text-[#FFFFFF] tracking-tight'>
                        Instant Off ramp
                      </p>
                      <p className='text-xs text-[#C8C8C8] tracking-tight mt-1'>
                        Instant off ramp from crypto to fiat
                      </p>
                    </div>
                  </div>
                </div>
                <div className='flex flex-col w-[330px] lg:w-[448px] items-center lg:mr-6 mt-6 lg:mt-0'>
                  <div
                    className='h-[434px] bg-[#F2F3F6] relative w-full flex flex-col overflow-hidden items-center rounded-xl mb-6'
                    id='animatedDiv4'
                    onMouseEnter={() => handleMouseEnter('animatedDiv4')}
                    onMouseLeave={() => handleMouseLeave('animatedDiv4')}
                  >
                    <div className='absolute mt-[30%]'>
                      <Player
                        ref={(ref) =>
                          (animatedDivRefs.current['animatedDiv4'] = ref)
                        }
                        loop={true}
                        src={gridFlow}
                        className={'w-[448px] h-[434px]'}
                        autoPlay={false}
                        keepLastFrame={true}
                      />
                    </div>
                    <img
                      src={AppImages.METAL_CARDS}
                      className='absolute w-[297px] h-[355px]'
                    />
                    <div className='max-w-[404px] absolute bottom-6 left-6'>
                      <p className='text-xl text-[#000000] tracking-tight'>
                        Both Physical and virtual card
                      </p>
                      <p className='text-xs text-[#555555] font-normal mt-1'>
                        Load across 16+ chains and 500+ tokens, linking them to
                        physical or virtual cards for easy spending.
                      </p>
                    </div>
                  </div>
                  <div
                    className='h-[208px] w-full bg-[#F2F3F6] relative flex flex-col overflow-hidden rounded-xl'
                    id='animatedDiv5'
                    onMouseEnter={() => handleMouseEnter('animatedDiv5')}
                    onMouseLeave={() => handleMouseLeave('animatedDiv5')}
                  >
                    <div className='absolute top-[9px] right-[-24px]'>
                      <Player
                        ref={(ref) =>
                          (animatedDivRefs.current['animatedDiv5'] = ref)
                        }
                        loop={true}
                        src={supportBusiness}
                        className={'w-[284px] h-[141px]'}
                        autoplay={false}
                        keepLastFrame={true}
                      />
                    </div>
                    <div className='max-w-[347px] absolute bottom-6 left-6'>
                      <p className='text-xl text-[#000000] tracking-tighter'>
                        Supports <br />
                        Businesses(KYB) with Accountant Login
                      </p>
                      <p className='text-xs text-[#555555] mt-1'>
                        for Both Physical and virtual card{' '}
                      </p>
                    </div>
                  </div>
                </div>
                <div className='flex flex-col w-[330px] items-center lg:mr-16 mt-6 lg:mt-0'>
                  <div className='h-[154px] bg-[#1F1F1F] relative w-full flex flex-col overflow-hidden rounded-xl mb-6'>
                    <div className='absolute right-2 top-[-14px]'>
                      <img
                        src={AppImages.BLUE_CARD}
                        className={'w-[193px] h-[114px]'}
                      />
                    </div>
                    <div className='max-w-[249px] absolute bottom-6 left-6'>
                      <p className='text-xl text-[#FFFFFF] tracking-tight'>
                        Low Markup Fee
                      </p>
                      <p className='text-xs text-[#999999] font-normal tracking-tight mt-1'>
                        Lowest markup fee on other currency spends
                      </p>
                    </div>
                  </div>
                  <div
                    className='h-[310px] w-full bg-[#FDF3D8] relative flex flex-col overflow-hidden rounded-xl mb-6'
                    id='animatedDiv6'
                    onMouseEnter={() => handleMouseEnter('animatedDiv6')}
                    onMouseLeave={() => handleMouseLeave('animatedDiv6')}
                  >
                    <div className='absolute mt-[50px]'>
                      <Player
                        ref={(ref) =>
                          (animatedDivRefs.current['animatedDiv6'] = ref)
                        }
                        loop={true}
                        src={cardLoad}
                        className={'max-w-[308px] max-h-[308px]'}
                        autoplay={false}
                        keepLastFrame={true}
                      />
                    </div>
                    <div className='max-w-[161px] absolute top-6 left-6'>
                      <p className='text-xl text-[#000000] tracking-tight'>
                        Load with any non custodial wallet
                      </p>
                      <p className='text-xs text-[#555555] mt-1'>
                        Easily load and spend from any non-custodial wallet,
                        across 40m+ POS
                      </p>
                    </div>
                  </div>
                  <div className='h-[154px] bg-[#F2F3F6] relative w-full flex flex-col overflow-hidden rounded-xl'>
                    <div className='absolute right-[-4px] bottom-5'>
                      <img
                        src={AppImages.CYPHER_BILL_PAYMENT}
                        className={'max-h-[156px] max-w-[135px]'}
                      />
                    </div>
                    <div className='max-w-[226px] absolute bottom-6 left-6'>
                      <p className='text-xl text-[#000000] tracking-tight'>
                        All of these in an app, dAapp, extension
                      </p>
                      <p className='text-xs text-[#999999] mt-1'>
                        All the controls in an app which <br /> is super
                        seemless
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='mt-12 lg:mt-32 w-full flex flex-col justify-center items-center'>
            <div className='w-full h-[1px] bg-[#EEEEEE]' />
            <div className='block md:hidden w-full h-[1px] bg-[#EEEEEE] mt-5 ' />
            <h1 className='text-2xl md:text-4xl font-bold text-center my-6 md:my-8'>
              Frequently Asked Questions
            </h1>
            <div className='block md:hidden w-full h-[1px] bg-[#EEEEEE] mb-5' />
            <div className='w-full h-[1px] bg-[#EEEEEE] ' />
            <div class='container px-6 mb-8 max-w-[920px] flex flex-col justify-center items-center mt-8 lg:mt-28'>
              <div className='w-full'>
                {cardFAQs.map((faq, index) => (
                  <div
                    key={index}
                    className={`p-8 rounded-2xl ${
                      expandedIndex === index ? 'bg-[#FFF9EA]' : ''
                    }`}
                  >
                    <div
                      className='flex justify-between items-center cursor-pointer'
                      onClick={() => toggleFAQ(index)}
                    >
                      <h2
                        className={`text-base md:text-2xl md:font-bold ${
                          expandedIndex === index
                            ? 'font-bold'
                            : 'formal-normal'
                        }`}
                      >
                        {faq.question}
                      </h2>
                      {expandedIndex === index && (
                        <IoIosArrowUp
                          className={'min-h-4 min-w-4 md:min-h-6 md:min-w-6'}
                        />
                      )}
                      {expandedIndex !== index && (
                        <IoIosArrowDown
                          className={'min-h-4 min-w-4 md:min-h-6 md:min-w-6'}
                        />
                      )}
                    </div>
                    {expandedIndex === index && (
                      <p className='mt-6 text-sm md:text-xl text-gray-600 font-normal'>
                        {faq.answer}
                      </p>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className='mt-[-150px] lg:mt-0'>
            <FooterSection />
          </div>
        </div>
      </div>
    </div>
  );
}
